import NurseNav from "../../pages/Dashboard/Nurse/NurseNav";
import NurseIndex from "../../pages/Dashboard/Nurse/NurseIndex";

const nurseRoutes = {
  path: "/nurse",
  element: <NurseNav />,
  children: [{ path: "/nurse", element: <NurseIndex /> }],
};

export default nurseRoutes;
